import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {AlertController} from '@ionic/angular';
import {DocumentTypes} from '../../definitions/document-types';
import {ConfigurationModel} from '../../models/configuration.model';
import {ConfigurationService} from '../../services/configuration.service';
import {AdjustDetailLinesDatesService} from '../../services/adjust-detail-lines-dates.service';

@Component({
    selector: 'datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss']
})

export class DatepickerComponent implements OnInit {

    @Input() document: DocumentModel;
    configuration: ConfigurationModel;

    constructor(private alertController: AlertController,
                private documentTypes: DocumentTypes,
                private configurationService: ConfigurationService,
                private adjustDetailLinesDates: AdjustDetailLinesDatesService) {
    }

    ngOnInit() {
        this.configuration = this.configurationService.getConfiguration();
        this.document.scheduledDate = this.document.scheduledDate ? this.document.scheduledDate : this.document.creationDate;
        this.checkStandardTime();
    }

    async changeDate() {
        const alert = await this.alertController.create({
            header: 'Select Date/Time',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'date',
                    type: 'date',
                    value: this.generateDate(this.document.scheduledDate)
                },
                {
                    name: 'time',
                    type: 'time',
                    value: this.generateTime(this.document.scheduledDate)
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        console.log('Confirm Cancel');
                    }
                }, {
                    text: 'Ok',
                    handler: data => {
                        this.document.scheduledDate = this.formDate(data.date, data.time);
                        this.adjustDetailLinesDates.adjustDates(this.document);
                        this.checkMinDate();
                    }
                }
            ]
        });
        await alert.present();
    }

    formDate(date: string, time: string) {
        const year = date.substr(0, 4);
        const month = date.substr(5, 2);
        const day = date.substr(8, 2);
        const hour = time.substr(0, 2);
        const minute = time.substr(3, 2);

        const resDate = new Date();
        resDate.setFullYear(+year, +month - 1, +day);
        resDate.setHours(+hour, +minute);
        return resDate.toISOString();
    }

    generateDate(date: string) {
        return date.substr(0, 10);
    }

    generateTime(time: string) {
        if (this.document.documentType === this.documentTypes.CONTRACT) {
            return this.configuration.standardContractTime ? this.configuration.standardContractTime :
                time.substr(11, 2) + ':' + time.substr(14, 2);
        }

        if (this.document.documentType === this.documentTypes.RETURN) {
            return this.configuration.standardReturnTime ? this.configuration.standardReturnTime :
                time.substr(11, 2) + ':' + time.substr(14, 2);
        }

        return time.substr(11, 2) + ':' + time.substr(14, 2);
    }

    checkMinDate() {
        if (this.document.detailLines.length > 0 && this.document.documentType !== this.documentTypes.RETURN) {
            let willAlert = false;
            for (const line of this.document.detailLines) {
                if (line.fromDate > this.document.scheduledDate) {
                    line.fromDate = this.document.scheduledDate;
                    willAlert = true;
                }
            }
            for (const line of this.document.detailLines) {
                if (line.toDate < line.fromDate) {
                    line.toDate = line.fromDate;
                    willAlert = true;
                }
            }
            if (willAlert) {
                alert('Detail lines updated');
            }
        }
    }

    private checkStandardTime() {
        if (this.document.documentType === this.documentTypes.CONTRACT) {
            const tempTime = this.configuration.standardContractTime ? this.configuration.standardContractTime :
                this.document.scheduledDate.substr(11, 2) + ':' + this.document.scheduledDate.substr(14, 2);
            this.document.scheduledDate = this.formDate(this.generateDate(this.document.scheduledDate), tempTime);
        }

        if (this.document.documentType === this.documentTypes.RETURN) {
            const tempTime = this.configuration.standardReturnTime ? this.configuration.standardReturnTime :
                this.document.scheduledDate.substr(11, 2) + ':' + this.document.scheduledDate.substr(14, 2);
            this.document.scheduledDate = this.formDate(this.generateDate(this.document.scheduledDate), tempTime);
        }
    }
}
